import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CookiesComponent} from '@ui/cookies/cookies.component';
import {RouterModule} from '@angular/router';
import {TuiButtonModule} from '@taiga-ui/core';
import {CoreModule} from '@core/core.module';

@NgModule({
  declarations: [CookiesComponent],
  imports: [CommonModule, RouterModule, TuiButtonModule, CoreModule],
  exports: [CookiesComponent],
})
export class CookiesModule {}
